define('modules/page_listing/controllers/search',['require','exports','module'],function(require, exports, module) {
  "use strict";

  var DELETE_KEY = 8,
      INTRO_KEY = 13,
      ESCAPE_KEY = 27,
      SPACE_KEY = 32,
      UP_KEY = 38,
      DOWN_KEY = 40;

  module.exports = {
    minSearchLength: 2,
    removeTagOnDelete: true,
    // this will handle the keys involved in selecting elements
    // so cursor won't move to the beginning nor end of input text
    onKeyDown: function(e) {
      var key = e && e.keyCode,
          taglistView = this.$taglist.currentView;

      switch(key){
        case DOWN_KEY:
          e.preventDefault();
          taglistView.selectNextTag();
          break;
        case UP_KEY:
          e.preventDefault();
          taglistView.selectPrevTag();
          break;
        case ESCAPE_KEY:
          e.preventDefault();
          taglistView.unselectAll();
          break;
      }
    },

    onKeyUp: function(e) {
      e.preventDefault();

      var key = e && e.keyCode,
          text = this.$("input").val();

      switch(key){
        // these three are handled when keydown, so do nothing
        case DOWN_KEY:
        case UP_KEY:
        case ESCAPE_KEY:
          break;
        case SPACE_KEY:
          this.extractTag(text);
          break;
        case INTRO_KEY:
          this.addTagToCloud();
          break;
        case DELETE_KEY:
          if (this.removeTagOnDelete && !this.searchText) {
            this.$tagcloud.currentView.removeLastTag();
          }
          this.updateTagList(text);
          break;
        default:
          this.updateTagList(text);
      }
    },

    updateTagList: function(text) {
          this.searchText = text;
          var tagList = this.collection.search(this.searchText);
          this.regions.taglist.currentView.collection.reset(tagList);
          this.toggleTagList(this.searchText.length < this.minSearchLength);
    },

    extractTag: function(text) {
      var tag = this.collection.searchTag(text);
      this.regions.tagcloud.currentView.addTag(tag);
      this.searchText = tag? "" : text;
      this.triggerMethod("render");
    },

    addTagToCloud: function(tag) {
      tag = tag || this.$taglist.currentView.getSelectedTag();
      this.$tagcloud.currentView.addTag(tag);
      this.$taglist.currentView.resetIndex();
      this.searchText = "";
      this.triggerMethod("render");
    },

    toggleTagList: function(isHidden) {
      this.$(".js-tag-list").toggleClass("hidden", isHidden);
    },

    toggleTagCloud: function(isHidden) {
      this.$(".js-tag-cloud").toggleClass("hidden", !!isHidden);
    }
  };

});

